<template>
  <div class="SelectBlock">
    <div @click='showing = true'>
      <slot></slot>
    </div>

    <transition name="fade-trans">
      <div v-if='showing' class="content-dropdown" :class="{alignToLeft}" ref="dropdown">
        <div v-for="item in blocks" class="p-3 preview-item" @click='selectBlock(item)'>
          <h4>{{ item.title }}</h4>
          <div class="iframe-wrapper">
            <iframe v-if='scale'
              :src="item.src"
              :style='`width: ${width}px;transform: scale(${scale}, ${scale})`'
            ></iframe>
            <div class='front'></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import axios from "axios"

export default {
  props: {
    config: Object,
    fullDomainLink: String,
    currentClientWidth: Number,
    alignToLeft: Boolean,
    position: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      blocks: [],
      scale: null,
      width: 0,
      showing: false,
    }
  },
  created() {
    this.previewAvailableBlocks()
  },
  beforeDestroy() {
    window.removeEventListener("click", this.checkPath)
  },
  methods: {
    selectBlock(item) {
      this.showing = false
      this.$emit('add-block', item)
    },
    checkPath(evt) {
      const path = evt.composedPath()
      let found
      for (const node of path) {
        if (this.$el === node) {
          found = true
          break
        }
      }
      if (!found) this.showing = false
    },
    calculateScale() {
      this.width = document.body.clientWidth
      this.scale = (this.$refs.dropdown.getBoundingClientRect().width - (2 * 16)) / this.width
    },
    async previewAvailableBlocks() {
      const position = this.position
      this.blocks = (await this.$store.dispatch("cachedGet", {
        endpoint: this.fullDomainLink + "/rest/V1/editor/list-available-blocks",
      })).data

      this.blocks = this.blocks.filter(block => block.position === position)
      for (const block of this.blocks) {
        block.src = `${this.fullDomainLink}/rest/V1/editor/preview-block/${block.id}?tailwind_config=${this.configParam.tailwindConfig}`
        block.contentUrl = `${this.fullDomainLink}/rest/V1/editor/preview-block/${block.id}`
      }
    },
  },
  computed: {
    configParam() {
      return encodeURIComponent(JSON.stringify(this.config))
    },
  },
  watch: {
    showing(val) {
      if (val) {
        window.addEventListener("click", this.checkPath)
        this.previewAvailableBlocks()
        this.$nextTick(() => this.calculateScale())
      } else {
        window.removeEventListener("click", this.checkPath)
      }
    },
    currentClientWidth() {
      this.calculateScale()
    },
  },
}

</script>

<style scoped>

.SelectBlock {
  position: relative;
}

.preview-item {
  transition-duration: .15s;
  cursor: pointer;
}

.preview-item:hover {
  background-color: rgb(248,248,248);
}

.preview-item + .preview-item {
  border-top: 1px solid rgb(228,228,228);
}

iframe {
  position: absolute;
  height: 1500px;
  border: none;
  overflow: hidden;

  transform-origin: top left;
}

h4 {
  margin: 0px;
  font-weight: 700;
}

.iframe-wrapper {
  position: relative;
  overflow: hidden;
  height: 150px;
  border-radius: 6px;
  border: 1px solid rgb(228,228,228);
  margin-top: 6px;
}

.front {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0%;
  top: 0%;
  z-index: 80;
}

.content-dropdown {
  position: absolute;
  background-color: white;
  border-radius: 6px;
  top: 100%;
  right: 0;
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.2);
  width: 450px;
}

.content-dropdown.alignToLeft {
  left: 0;
  right: unset;
}

</style>
